import { render, staticRenderFns } from "./OrderDetailDispatch.vue?vue&type=template&id=00b6223d"
import script from "./OrderDetailDispatch.vue?vue&type=script&lang=js"
export * from "./OrderDetailDispatch.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailDispatch.vue?vue&type=style&index=0&id=00b6223d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports